import React, { Component, Fragment } from 'react'
import '../../styles/Popup.module.css'
import {
    Form,
    Select,
    Input,
    Button,
    Upload,
    Row,
    Col,
} from 'antd';
import ImgCrop from 'antd-img-crop';
import ReactDropzone from "react-dropzone";
import { connect } from 'react-redux';
import { requestServerPost, selectPage } from '../../actions';

import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import PopupManager from '../../managers/PopupManager';
import ScreenEventPlaylistSelectorPopup from './ScreenEventPlaylistSelectorPopup';
const { Option } = Select;


class AssignAndPublishEventPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        const { requestServerPost, usertoken, selectedBrandData, eventPlaylistData = null } = this.props;
        const previewStyle = {
            display: 'inline',
            width: 300,
            height: 100,
        };
        return (
            <div className="popupcontentcontainer" style={{ height: "100%", width: "100%" }}>
                <ScreenEventPlaylistSelectorPopup data={eventPlaylistData}></ScreenEventPlaylistSelectorPopup>
            </div >
        );
    }
}

const Styles = {

}


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerPost, requestServerPost, selectPage })(AssignAndPublishEventPage);
